/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, {FC, useContext, useEffect, useState} from 'react'
import { Context } from '../../../context/NewCycleContext'
import {BaseInput, FileInput, SwitchInput, Text, TextareaInput} from '../../atoms'
import { ContentSection } from '../../organisms'
import {useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {detail_new_cycle} from "../../../redux/actions/group_cycle/detail_new_cycle";

const NewForm: FC = () => {
  const dispatch = useDispatch()
  let { id, idCycle } = useParams();
  const token = useSelector((state: any) => state.login.access)
  const { formData, handleChangeFormData: handleChange, handleUpdateFormData: handleData } = useContext(Context)

  const detail_cycle = useSelector((state: any) => state.detail_new_cycle.data)

  useEffect(() => {
    if (idCycle) {
      dispatch(detail_new_cycle({ token, id: Number(idCycle) }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setTimeout(() => {
      handleChange({group: Number(id)})
    }, 1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!!idCycle) {
      setTimeout(() => {
        handleData(detail_cycle)
      }, 2000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [isTitleValid, setTitleValid] = useState<boolean>(false)
  const [isDescriptionValid, setIsDescriptionValid] = useState<boolean>(false)

  useEffect(() => {
    setTitleValid(formData.title.length > 2)
  }, [formData.title])
  useEffect(() => {
    setIsDescriptionValid(formData.description.length > 2)
  }, [formData.description])

  return (
    <ContentSection
      style={css`display: grid; gap: 18px;`}
      header={
        <React.Fragment>
          <Text textType='h4' weight='black'>{idCycle ? 'Editar':'Nueva'} noticia por ciclo</Text>
        </React.Fragment>
      }
    >
      <BaseInput
        label='Título'
        value={formData.title}
        onChange={(value) => handleChange({ title: value })}
        placeholder='Escribe el titulo de tu entrada'
        maxLength={500}
        error={!isTitleValid && formData.title.length > 0}
        success={isTitleValid}
        hint={!isTitleValid && formData.title.length > 0 ? 'Digite mas de dos letras' : ''}
      />
      <TextareaInput
        label='Contenido'
        value={formData.description}
        onChange={(value) => handleChange({ description: value })}
        placeholder='Escribe el contenido de tu entrada'
        maxLength={1500}
        error={!isDescriptionValid && formData.description.length > 0}
        success={isDescriptionValid}
        hint={!isDescriptionValid && formData.description.length > 0 ? 'Digite mas de dos letras' : ''}
      />
      <div style={{ width: 360 }}>
        <FileInput
          label={formData.is_image ? 'Imagen' : 'Video'}
          value={formData.image}
          onChange={(value) => handleChange({ image: value })}
          accept={formData.is_image ? 'image/*' : 'video/*'}
        />
      </div>
      <SwitchInput checked={formData.is_image}
        onCheckedChange={(value) => handleChange({ is_image: value })}
        label={formData.is_image ? 'Subir Imagen': 'Subir Video'}
      />
      <div style={{ width: 360 }}>
        <FileInput
          label={formData.is_image_description ? 'Imagen Descripción' : 'Video Descripción'}
          value={formData.image_description}
          onChange={(value) => handleChange({ image_description: value })}
          accept={formData.is_image_description ? 'image/*' : 'video/*'}
        />
      </div>
      <SwitchInput checked={formData.is_image_description}
        onCheckedChange={(value) => handleChange({ is_image_description: value })}
        label={formData.is_image_description ? 'Subir Imagen': 'Subir Video'}
      />

      <SwitchInput checked={formData.active}
        onCheckedChange={(value) => handleChange({ active: value })}
        label={formData.active ? 'Activo': 'Inactivo'}
      />
    </ContentSection>
  )
}

export default NewForm
